import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppSettings, LoginResult, TokenData } from '../../models';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthenticationService } from '../../services';
import { ChangePasswordDialogComponent } from 'src/app/pages/profile/change-password-dialog/change-password-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { RoleEnum } from '../../enums';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserMenuComponent implements OnInit {
  public userImage = 'assets/img/users/default-user.jpg';
  tokenData: TokenData = {};
  providerRole = [RoleEnum.Provider];

  constructor(
    private jwtHelper: JwtHelperService,
    public dialog: MatDialog,
    private authService: AuthenticationService,
    private router: Router,
    private translateService: TranslateService,
    private appSettings: AppSettings
  ) {}

  ngOnInit() {
    const token = this.jwtHelper.tokenGetter();
    this.tokenData = this.jwtHelper.decodeToken(token);
    const userData = JSON.parse(localStorage.getItem('user_data')) as LoginResult;
    this.tokenData.user_name = userData.setting.personName;
    if (this.authService.hasPermission(['Provider'])) {
      this.setProviderDisplayName(userData);
      this.translateService.onLangChange.subscribe(() => {
        this.setProviderDisplayName(userData);
      });
    }
  }

  private setProviderDisplayName(userData: LoginResult): void {
    this.tokenData.user_name =
      this.appSettings.settings.language === 'ar'
        ? userData.setting.personNameAr
        : userData.setting.personNameEn;
  }

  logout() {
    this.authService.logout();
  }

  changePassword() {
    const dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
      data: {},
      disableClose: true,
      autoFocus: true,
      width: '500px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.authService.logout();
      }
    });
  }

  updateProfile() {
    this.router.navigate(['./profile']);
  }
}
